export const formatFileSize = (bytes: number): string => {
  const units = ['B', 'KB', 'MB'];
  const kilobyte = 1024;
  let size = bytes;
  let i = 0;

  while (size >= kilobyte && i < units.length - 1) {
    size /= kilobyte;
    i += 1;
  }

  return `${size.toFixed(2)} ${units[i]}`;
};
